import { useGamesPage } from "modules/games/context";
import { FC } from "react";
import ClearButton from "shared/components/ClearButton";
import Combobox from "shared/components/Combobox";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";

const PageFilterBar: FC = () => {
  const {
    searchData,
    serviceTagFilterApi,
    onClearFilters,
    themeTagFilterApi,
    metadataTagFilterApi,
    statusFilterData,
  } = useGamesPage();

  const {
    selectedServiceTags,
    handleSelectGroupedOptions,
    handleClearSelectedOptions,
    groupedServiceTags,
    serviceTagsSearchQuery,
    handleSearchServiceTags,
  } = serviceTagFilterApi;

  const {
    selectedThemeTags,
    handleSelectGroupedOptions: handleSelectGroupedThemeTags,
    handleClearSelectedOptions: handleClearSelectedThemeTags,
    groupedThemeTags,
    themeTagsSearchQuery,
    handleSearchThemeTags,
  } = themeTagFilterApi;

  const {
    selectedMetadataTags,
    handleSelectGroupedOptions: handleSelectGroupedMetadataTags,
    handleClearSelectedOptions: handleClearSelectedMetadataTags,
    groupedMetadataTags,
    metadataTagsSearchQuery,
    handleSearchMetadataTags,
  } = metadataTagFilterApi;

  const shouldShowClearButton =
    selectedServiceTags.length > 0 ||
    selectedThemeTags.length > 0 ||
    selectedMetadataTags.length > 0;

  return (
    <FlexCenter columnGap={"1rem"} marginBottom={"1rem"}>
      <SearchField placeholder="Game name" {...searchData} />
      <Filter {...statusFilterData} title="Status" />
      <Combobox
        title="Service tags"
        selectedValues={selectedServiceTags}
        comboElements={groupedServiceTags}
        onSelectGroupedOptions={handleSelectGroupedOptions}
        onClearSelectedOptions={handleClearSelectedOptions}
        searchQuery={serviceTagsSearchQuery}
        setSearchQuery={handleSearchServiceTags}
      />

      <Combobox
        title="Theme tags"
        selectedValues={selectedThemeTags}
        comboElements={groupedThemeTags}
        onSelectGroupedOptions={handleSelectGroupedThemeTags}
        onClearSelectedOptions={handleClearSelectedThemeTags}
        searchQuery={themeTagsSearchQuery}
        setSearchQuery={handleSearchThemeTags}
      />

      <Combobox
        title="Metadata tags"
        selectedValues={selectedMetadataTags}
        comboElements={groupedMetadataTags}
        onSelectGroupedOptions={handleSelectGroupedMetadataTags}
        onClearSelectedOptions={handleClearSelectedMetadataTags}
        searchQuery={metadataTagsSearchQuery}
        setSearchQuery={handleSearchMetadataTags}
      />

      {shouldShowClearButton && <ClearButton onClearFilters={onClearFilters} />}
    </FlexCenter>
  );
};

export default PageFilterBar;
